'use client';

import { c as _c } from "react/compiler-runtime";
import { PropsWithChildren } from 'react';
import { XIcon } from '@material-bank/mtag-icons';
type MorphDialogCloseProps = {
  onClose: () => void;
  className?: string;
};
export function MorphDialogClose(t0) {
  const $ = _c(6);
  const {
    onClose,
    className,
    children
  } = t0;
  const t1 = className ?? "absolute right-4 top-4 rounded-sm opacity-70 transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2";
  let t2;
  if ($[0] !== children) {
    t2 = children ?? <XIcon className="size-4" />;
    $[0] = children;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== onClose || $[3] !== t1 || $[4] !== t2) {
    t3 = <button type="button" aria-label="Close" className={t1} onClick={onClose}>{t2}</button>;
    $[2] = onClose;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}